export { default as CoreDialogsContainer } from './Dialogs';
